import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const folderTreeV2Theme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      tagBg: theme.color.focus[5],
      tagText: theme.color.text.core['-secondary'],
      tagDescription: theme.color.text.core['-primary'],
      parentSystemBackground: theme.color.surface[2],
      systemBackground: theme.color.grid.stripe,
      selectedTagBg: theme.color.grid.select,
      tagEvenBg: theme.color.grid['stripe'],
      tagOddBg: theme.color.grid['base'],
      tagHoverBg: theme.color.grid.hover,
      selectedTagBorder: theme.color.focus[3],
      searchBarBg: theme.color.surface.cool[2],
    },
  ]),
);
